export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10594.2c64a439.jpg";